var _style, _rect, _rect2, _rect3, _line, _rect4, _polygon, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntitArbre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Entit\\xE9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.stenta0{fill:#605F71;}\r\n\t.stenta1{fill:none;stroke:#605F71;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.stenta2{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.1,
    y: 9,
    className: "stenta0",
    width: 6.4,
    height: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "stenta0",
    width: 6.5,
    height: 17
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7,
    y: 6.3,
    className: "stenta0",
    width: 6.3,
    height: 10.7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "stenta1",
    x1: 13.9,
    y1: 0.4,
    x2: 13.9,
    y2: 4.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    className: "stenta0",
    width: 3.5,
    height: 1.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "stenta0",
    points: "13.9,2.6 10.7,5.9 17,5.9 "
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 16.5,
    className: "stenta2",
    width: 17,
    height: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.4,
    y: 6.8,
    className: "stenta2",
    width: 1.7,
    height: 1.7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2.4,
    y: 3.2,
    className: "stenta2",
    width: 1.7,
    height: 1.7
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2.4,
    y: 14,
    className: "stenta2",
    width: 1.7,
    height: 1.7
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2.4,
    y: 10.4,
    className: "stenta2",
    width: 1.7,
    height: 1.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 10.4,
    className: "stenta2",
    width: 1.7,
    height: 1.7
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 6.8,
    className: "stenta2",
    width: 1.7,
    height: 1.7
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 14,
    className: "stenta2",
    width: 1.7,
    height: 1.7
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 7.4,
    y: 14,
    className: "stenta2",
    width: 1.7,
    height: 1.7
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 7.4,
    y: 10.4,
    className: "stenta2",
    width: 1.7,
    height: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntitArbre);
export default __webpack_public_path__ + "static/media/Entité-arbre.6cc3d376d36e452d7b2f7250ab4b9b99.svg";
export { ForwardRef as ReactComponent };